const SearchParams = Object.freeze({
  EMAIL: 'email',
  REDIRECT_URL: 'redirect-url',
  ROLE: 'role',
} as const);

export type SearchParams = (typeof SearchParams)[keyof typeof SearchParams];
export default SearchParams;
